import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";

export interface AddressSuggestion {
  place_name: string;
  geometry:{ 
    type: string; 
    coordinates: [number, number]  // [lng, lat]
  };
  text: string;
  address?: string;
  context?: Array<{ id: string; text: string }>;
}

@Injectable({
  providedIn: 'root'
})
export class AddressAutocompleteService {

  private apiUrl = environment.apiUrl +'/api/geocode';

  constructor(private http: HttpClient) { }

  getSuggestions(query: string): Observable<AddressSuggestion[]> {
    if (!query || query.trim().length === 0) {
      return new Observable(subscriber => subscriber.next([]));
    }

    const params = new HttpParams().set('query', query)

    return this.http.get<AddressSuggestion[]>(this.apiUrl, { params });
  }
}
